import { COLORS } from "../../../customStyles";

export default (theme) => ({
    appBar: {
        backgroundColor: COLORS.FDI_YELLOW,
    },
});
